export const defaultExpandedId = `fs-default-expanded`;
